export interface NavItem {
  label: string;
  path: string;
}

export const brand = {
  legalName: "KAL LORDS ZERO21 DJT TECHNOLOGIES PVT. LTD.",
  shortName: "KAL LORDS ZERO21 DJT",
  descriptor: "EV RETROFIT TECHNOLOGIES",
  tagline: "Transform Your Existing Vehicle Into Electric.",
  secondary: "Don't Replace. Retrofit. Electrify.",
  closing: "Your Vehicle Has More Life. Give It an Electric Future.",
};

export const primaryNav: NavItem[] = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "EV Retrofit", path: "/ev-retrofit" },
  { label: "Solutions", path: "/solutions" },
  { label: "Technology", path: "/technology" },
  { label: "Fleet", path: "/fleet" },
  { label: "Projects", path: "/projects" },
  { label: "Partners", path: "/partners" },
  { label: "Contact", path: "/contact" },
];

export const footerNav: NavItem[] = [
  ...primaryNav,
  { label: "FAQ", path: "/faq" },
];

export const footerServices: NavItem[] = [
  { label: "2-Wheeler Retrofit", path: "/solutions" },
  { label: "3-Wheeler Retrofit", path: "/solutions" },
  { label: "4-Wheeler Retrofit", path: "/solutions" },
  { label: "Commercial Retrofit", path: "/solutions" },
  { label: "Fleet Electrification", path: "/fleet" },
];

export const legalLinks: NavItem[] = [
  { label: "Privacy Policy", path: "/privacy-policy" },
  { label: "Terms & Conditions", path: "/terms" },
  { label: "Cookie Policy", path: "/cookie-policy" },
];

export const journeySteps: string[] = [
  "Existing Vehicle",
  "Vehicle Assessment",
  "Retrofit Engineering",
  "Electric Powertrain",
  "Battery System",
  "Connected EV",
  "Charging",
  "Service",
  "Sustainable Mobility",
];